import api from '@pray/shared/utils/api';

export async function getPayoutTransactionsReport({ artistId = '', year = 0 } = {}) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!year) throw new Error('Year is required');

  const params = {
    download_csv: true,
    year,
  };

  const options = {
    responseType: 'blob',
  };

  const url = `/web/studio/artists/${artistId}/payouts/transactions`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
}
